import {action, computed, observable} from "mobx";

import {DashboardSolution, IDashboardSolution} from "./entities/DashboardSolution";
import {IBundle} from "./BundleData";
import {API} from "../api";
import {IBadgeGroup} from "shared/IBadgeGroup";
import {DateTime} from "luxon";
import {Transport} from "data/transport";
import {CollapsedNotification, INotification} from "data/entities/INotification";
import {UIState} from "data/UIState";

function createDashboardSolutions(iSolutions:IDashboardSolution[]) {
  const solutions:DashboardSolution[] = [];
  for(let i=0;i<iSolutions.length;i++) {
    solutions.push(new DashboardSolution(iSolutions[i]));
  }
  return solutions;
}

class _DashboardData {

  @observable loaded = false;
  @observable active:DashboardSolution[];
  @observable annual:DashboardSolution[];
  @observable archived:DashboardSolution[];
  @observable companyBooth:IBundle;
  @observable selectedDashboardSolution:DashboardSolution|null = null;
  @observable singleSolution:{isSingleSolution:boolean;name:string;openDate:Date; solutionLogo:string; };
  @observable collapsedNotifications:CollapsedNotification[] = [];

  badgeGroups:IBadgeGroup[] = [];

  @observable removedDashboardSolutionName = "";

  @computed get allDashboardSolutions() {
    return [...this.active, ...this.annual, ...this.archived];
  }

  // filter out the ones with no earned date??
  @computed get badgedDashboardSolutions() {

    const badgedDashboardSolutions:DashboardSolution[] = [];
    for(let i=0;i<this.allDashboardSolutions.length;i++) {
      if(this.allDashboardSolutions[i].badgeEarned) { //} && null!=this.allDashboardSolutions[i].badgeEarnedDate) {
        badgedDashboardSolutions.push(this.allDashboardSolutions[i]);
      }
    }
    //badgedDashboardSolutions.sort((a:DashboardSolution, b:DashboardSolution) => {a.})
    return badgedDashboardSolutions;
  }

  @action removeDashboardSolution = (dashboardSolution:DashboardSolution, password:string):Promise<void> => new Promise((resolve, reject) => {
    API.post(`/cmd/removeParticipation/${dashboardSolution._id}`, {password:password})
      .then(response => {
        const idx = this.active.findIndex((ds:DashboardSolution)=> ds._id===dashboardSolution._id);
        if(idx > -1) {
          this.removedDashboardSolutionName = this.active[idx].name
          this.active.splice(idx, 1);
        }
        resolve();
      })
      .catch((error) => {
        reject(error);
      })
  });

  @action dismissNotification = (collapsedNotification:CollapsedNotification) => {
    API.post(`/dismissNotifications`, {
      dismissed:true,
      notificationIds:collapsedNotification.notificationIds()
    })
      .then(()=>{
        // console.log("dismissed", notification);

        const idx = this.collapsedNotifications.findIndex((n:any)=> n.id===collapsedNotification.id);
        if(idx>-1) {
          this.collapsedNotifications.splice(idx, 1);
        }

      })
      .catch((reason)=>{
        console.log("failed to dismiss", collapsedNotification);
        console.log(reason)
      });
  }

  processNotifications= (notifications:INotification[]):CollapsedNotification[]  => {
    const collapsedNotifications:CollapsedNotification[] = [];
    const user = UIState.user;
    if(user && notifications) {
      for (let i = 0; i < notifications.length; i++) {
        const notification = notifications[i];
        notification.title = notification.title.replace(/{{firstName}}/g, user.firstName);
        notification.title = notification.title.replace(/{{firstName}}/g, user.lastName);
        notification.title = notification.title.replace(/{{email}}/g, user.email);
        notification.message = notification.message.replace(/{{firstName}}/g, user.firstName);
        notification.message = notification.message.replace(/{{firstName}}/g, user.lastName);
        notification.message = notification.message.replace(/{{email}}/g, user.email);
        let notificationCollapsed = false;
        if(collapsedNotifications.length>0) {
          for(let j=0;j<collapsedNotifications.length;j++) {
            if(collapsedNotifications[j].matches(notification)) {
              collapsedNotifications[j].addNotification(notification);
              notificationCollapsed = true;
              break;
            }
          }
        }
        if(!notificationCollapsed) {
          collapsedNotifications.push(new CollapsedNotification(notification));
        }
      }
    }
    return collapsedNotifications;
  }

  load = () => new Promise<void>((resolve, reject) => {
    API.get('/dashboard')
      .then(response => {
        this.active = createDashboardSolutions( response.solutions.active );
        this.annual = createDashboardSolutions( response.solutions.annual );
        this.archived = createDashboardSolutions( response.solutions.archived );
        this.badgeGroups = response.badgeGroups ? response.badgeGroups : [];
        this.loaded = true;
        this.companyBooth = response.companyBooth;
        this.singleSolution = response.singleSolution;
        this.collapsedNotifications = this.processNotifications(response.notifications);
        resolve();
      })
      .catch((reason)=>{
        reject(reason);
      });
  });

}

// Singleton
const DashboardData = new _DashboardData();
export default DashboardData;
